import { DialogService } from './dialog'

const AudeDialogPlugin = {
  install (Vue) {
    Vue.prototype.$dialog = DialogService
  }
}

export { AudeDialogPlugin }
